import * as file from '../../art/form/file.art';
import * as img from '../../art/form/img.art';
import * as text from '../../art/form/text.art';
import * as radio from '../../art/form/radio.art';
import * as checkbox from '../../art/form/checkbox.art';
import * as select from '../../art/form/select.art';
import * as checkboxSelect from '../../art/form/checkbox-select.art';
import * as textarea from '../../art/form/textarea.art';
import * as time from '../../art/form/time.art';
import * as line from '../../art/form/line.art';
import * as desc from '../../art/form/desc.art';
import * as policy from '../../art/form/policy.art';

export const fieldArts = {
  FIELDFILE: {
    pc: file,
    wap: file
  },
  FIELDIMG: {
    pc: img,
    wap: img
  },
  FIELDTEXT: {
    pc: text,
    wap: text
  },
  FIELDRADIO: {
    pc: radio,
    wap: radio
  },
  FIELDCHECKBOX: {
    pc: checkbox,
    wap: checkbox
  },
  FIELDSELECT: {
    pc: select,
    wap: select
  },
  FIELDCHECKBOXSELECT: {
    pc: checkboxSelect,
    wap: checkboxSelect
  },
  FIELDTEXTAREA: {
    pc: textarea,
    wap: textarea
  },
  FIELDTIME: {
    pc: time,
    wap: time
  },
  FIELDLINE: {
    pc: line,
    wap: line
  },
  FIELDDESC: {
    pc: desc,
    wap: desc
  },
  FIELDPOLICY: {
    pc: policy,
    wap: policy
  }
};